import { useI18n } from "@core/i18n/i18n";
import { MedicalProfession, medicalProfessions } from "@domain/localization/country";
import { WordingKey } from "@typings/i18n-typings";
import { useCallback } from "react";

const ALL_MEDICAL_PROFESSIONS_TRANSLATION_KEYS = {
	[MedicalProfession.EmployedPT]: "global.medicalProfession.employedPt",
	[MedicalProfession.IndependentPT]: "global.medicalProfession.independentPt",
	[MedicalProfession.OccupationalPT]: "global.medicalProfession.occupationalPt",
	[MedicalProfession.PmrPhysician]: "global.medicalProfession.pmrPhysician",
	[MedicalProfession.Eapa]: "global.medicalProfession.eapa",
	[MedicalProfession.PsychomotorTherapist]: "global.medicalProfession.psychomotorTherapist",
	[MedicalProfession.Neurologist]: "global.medicalProfession.neurologist",
	[MedicalProfession.Other]: "global.medicalProfession.other",
	[MedicalProfession.None]: "global.medicalProfession.none",
} satisfies Record<MedicalProfession, WordingKey>;

interface useMedicalProfessionHook {
	formatMedicalProfession: (profession: MedicalProfession) => string;
}

export function useMedicalProfession(): useMedicalProfessionHook {
	const { format } = useI18n();

	const formatMedicalProfession = useCallback(
		(profession: MedicalProfession) =>
			medicalProfessions.includes(profession)
				? format(ALL_MEDICAL_PROFESSIONS_TRANSLATION_KEYS[profession])
				: format("global.empty"),
		[format],
	);
	return { formatMedicalProfession };
}
